import { DefaultSeo } from 'next-seo'

import { Data } from '@/src/types/app.type'

export const Seo = (data: Data) => {
  return (
    <DefaultSeo
      title={data?.title_soc || 'Meet'}
      defaultTitle={data?.title_soc || 'Meet'}
      description={data?.description_soc || 'Meet'}
      twitter={{
        handle: data?.img_soc || '',
        cardType: 'summary_large_image',
      }}
      openGraph={{
        url: 'https://meet.proofix.ru',
        images: [
          {
            url: data?.img_soc || '',
            type: 'image/png',
            width: 2000,
            height: 1000,
          },
        ],
        site_name: data?.title_soc || 'Meet',
        type: 'article',
      }}
      additionalMetaTags={[
        {
          property: 'theme-color',
          content: '#070707',
        },
      ]}
      additionalLinkTags={[
        {
          rel: 'icon',
          href: data?.favicon || '/favicon.ico',
        },
        {
          rel: 'apple-touch-icon',
          href: data?.img_soc || '',
          sizes: '180x180',
        },
      ]}
    />
  )
}
